export const ActiveStatus = [
    { name: 'ACTIVE', code: true },
    { name: 'INACTIVE', code: false }
]